import React, { useEffect, useState } from 'react';
import {
    isPushSupported,
    getSubscriptionState,
    enableDesktopNotifications,
    disableDesktopNotifications,
} from '../../../utils/pushNotifications';

// Compact opt-in control for browser/OS (desktop) notifications. Shows the
// current state and lets the user turn push on or off. Hidden entirely on
// browsers that don't support Web Push.
export default function DesktopNotificationToggle() {
    const [state, setState] = useState({ supported: true, subscribed: false, permission: 'default' });
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState('');

    const refresh = async () => setState(await getSubscriptionState());

    useEffect(() => {
        if (!isPushSupported()) {
            setState((s) => ({ ...s, supported: false }));
            return;
        }
        refresh();
    }, []);

    if (!state.supported) { return null; }

    const onEnable = async () => {
        setBusy(true); setMsg('');
        const res = await enableDesktopNotifications();
        if (!res.ok) {
            const reasons = {
                denied: 'Permission was blocked. Allow notifications for this site in your browser settings.',
                unsupported: 'This browser does not support desktop notifications.',
                'sw-failed': 'Could not start the notification worker.',
                'server-disabled': 'Desktop push is not configured on the server yet.',
            };
            setMsg(reasons[res.reason] || 'Could not enable desktop notifications.');
        }
        await refresh();
        setBusy(false);
    };

    const onDisable = async () => {
        setBusy(true); setMsg('');
        await disableDesktopNotifications();
        await refresh();
        setBusy(false);
    };

    const blocked = state.permission === 'denied';

    return (
        <div className="p-2 border-top small">
            <div className="d-flex align-items-center gap-2">
                <span className="me-auto text-muted">🖥️ Desktop notifications</span>
                {blocked ? (
                    <span className="badge bg-secondary">Blocked</span>
                ) : state.subscribed ? (
                    <button className="btn btn-sm btn-outline-secondary" onClick={onDisable} disabled={busy}>
                        {busy ? '…' : 'Turn off'}
                    </button>
                ) : (
                    <button className="btn btn-sm btn-primary" onClick={onEnable} disabled={busy}>
                        {busy ? '…' : 'Turn on'}
                    </button>
                )}
            </div>
            {(msg || blocked) && (
                <div className="text-muted mt-1" style={{ fontSize: '0.72rem' }}>
                    {msg || 'Notifications are blocked in your browser settings for this site.'}
                </div>
            )}
        </div>
    );
}
